import { Cookie } from '@repo/tools'
import { create } from 'zustand'
import type { GlobalStore, Theme, UserDTO } from './global.types'

const userProfileInitial: UserDTO = {}

const getInitialTheme = () => {
  const savedTheme = Cookie.get('theme')
  return savedTheme as Theme
}

export const useGlobalStore = create<GlobalStore>((set) => ({
  user: userProfileInitial,
  setUser: (newUser: UserDTO) => set(() => ({ user: newUser })),
  theme: getInitialTheme(),
  setTheme: (newTheme: Theme) => {
    Cookie.set('theme', newTheme, { path: '/' })
    set(() => ({ theme: newTheme }))
  },
}))
